import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import ShareBtn from './ShareBtn';

const BreadCrumbs = () => (
  <>
    <div className="tasklist__nav">
      <div className="breadcrumbs">
        <Link className="breadcrumb__link" to="/checklists">All</Link>
        <FontAwesomeIcon className="breadcrumb__icon" icon={faChevronRight} />
        <h2>Test</h2>
      </div>
      <ShareBtn />
    </div>
  </>
);

export default BreadCrumbs;
